<script setup lang="ts">
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useNewsSettingsStore } from '@/stores/newsSettingsStore.ts'
import ToggleSwitch from '@/components/Elements/ToggleSwitch/ToggleSwitch.vue'
import RangeSlider from '@/components/Elements/Forms/RangeSlider.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const newsSettings = useNewsSettingsStore()

const updateMinimumShipsPerSide = (value: number) => {
  newsSettings.setMinimumShipsPerSide(value)
}
</script>

<template>
  <SmallModel :title="t('modals.newsSettings.title')">
    <StandardCard class="p-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">{{ t('modals.newsSettings.hideSmallBattles') }}</div>
          <small class="text-gray-500">{{ t('modals.newsSettings.hideSmallBattlesDescription') }}</small>
        </div>
        <div>
          <ToggleSwitch v-model="newsSettings.hideSmallBattles" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">{{ t('modals.newsSettings.minimumShipsPerSide') }}</div>
          <small class="text-gray-500">{{ t('modals.newsSettings.minimumShipsDescription') }}</small>
        </div>
        <div class="flex items-center">
          <RangeSlider
            :modelValue="newsSettings.minimumShipsPerSide"
            :min="1"
            :max="50"
            :step="1"
            class="w-20 mr-2"
            @update:modelValue="updateMinimumShipsPerSide"
          />
          <span class="text-metal-300 min-w-[3ch]">{{ newsSettings.minimumShipsPerSide }}</span>
        </div>
      </div>
    </StandardCard>
  </SmallModel>
</template>

<style scoped lang="scss"></style> 